import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  Divider,
  Typography,
  MenuItem,
  Snackbar,
  Alert,FormControlLabel,Switch,
} from "@mui/material";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import WarehouseMappingActionMenu from "./WarehouseMappingActionMenu";
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddUpdateWarehousemapping = ({
  formData,
  setFormData,
  setIsFormOpen,
  LoadWarehouseMappingList,
  handleBackWinderMachineEntry,
}) => {
  const [isEdit, setIsEdit] = useState(!!formData.warehouse_mapping_id);
  const [warehouses, setWarehouses] = useState([]);
  const [zonePackageList, setZonePackageList] = useState([]);
  const [binTypes, setBinTypes] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("warning");
  const [isZoneLoaded, setIsZoneLoaded] = useState(false);

  const showAlert = (msg, severity = "warning") => {
    setAlertMessage(msg);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  // ✅ Load ZonePackage & Warehouse
  useEffect(() => {
    if (!isZoneLoaded) loadZonePackageAndWarehouse();
  }, []);

  const loadZonePackageAndWarehouse = async () => {
    try {
      let company_id = localStorage.getItem("companyid");
      let plant_id = 1;
      let user_id = localStorage.getItem("userID");

      const commonPayload = {
        p_company_id: company_id,
        p_plant_id: plant_id,
        p_companyid: company_id,
        p_plantid: plant_id,
        p_created_by: user_id,
      };

      const [zonePkgRes, whRes] = await Promise.all([
        callApi(
          Warehouse_API_ENDPOINTS.warehousemapping.zonepackagelist,
          "POST",
          { "Content-Type": "application/json" },
          commonPayload
        ),
        callApi(
          Warehouse_API_ENDPOINTS.warehousemapping.warehouselist,
          "POST",
          { "Content-Type": "application/json" },
          commonPayload
        ),
      ]);

      if (zonePkgRes?.length > 0) setZonePackageList(zonePkgRes);
      if (whRes?.length > 0) setWarehouses(whRes);

      setIsZoneLoaded(true);
    } catch (error) {
      console.error("Error loading dropdown data:", error);
      showAlert("Failed to load Zone/Package or Warehouse list.", "error");
    }
  };

  // ✅ Load Bin Types based on Warehouse
  useEffect(() => {
    if (formData.warehouse_id) {
      loadBinTypes(formData.warehouse_id);
    } else {
      setBinTypes([]);
    }
  }, [formData.warehouse_id]);

  const loadBinTypes = async (warehouse_id, preselectBinTypeId = null) => {
    try {
      const payload = {
        p_companyid: localStorage.getItem("companyid"),
        p_plantid: 1,
        p_warehouse_id: warehouse_id,
        p_created_by: localStorage.getItem("userID"),
      };

      const binRes = await callApi(
        Warehouse_API_ENDPOINTS.warehousemapping.bintypelist,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );

      if (binRes?.length > 0) {
        setBinTypes(binRes);

        if (isEdit && preselectBinTypeId) {
          const exists = binRes.find(
            (b) => b.bin_type_id === preselectBinTypeId
          );
          if (exists) {
            setFormData((prev) => ({
              ...prev,
              bin_type_id: preselectBinTypeId,
            }));
          } else {
            setFormData((prev) => ({ ...prev, bin_type_id: "" }));
          }
        }
      } else {
        setBinTypes([]);
      }
    } catch (error) {
      console.error("Error loading bin types:", error);
      showAlert("Failed to load Bin Types.", "error");
    }
  };

  const handleChange = (field, value) => {
    let package_type = "";
    let region = "";

    if (field === "code") {
      [package_type, region] = value.split("-");
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "code" ? { package_type, region } : {}),
      ...(field === "warehouse_id" ? { bin_type_id: "" } : {}),
    }));
  };

  const validateFields = () => {
    if (!formData.code) {
      showAlert("Zone & Package Mode selection is required.");
      return false;
    }
    if (!formData.warehouse_id) {
      showAlert("Warehouse selection is required.");
      return false;
    }
    if (!formData.bin_type_id) {
      showAlert("Bin Type selection is required.");
      return false;
    }
    return true;
  };

  // ✅ Save (keep form open, turn edit mode on)
  const handleSave = async () => {
    if (!validateFields()) return;

    const payload = {
      p_mapping_id: formData.warehouse_mapping_id || 0,
      p_warehouse_id: formData.warehouse_id,
      p_region: formData.region,
      p_package_type: formData.package_type,
      p_bin_type_id: formData.bin_type_id,
      p_companyid: localStorage.getItem("companyid"),
      p_plantid: 1,
      p_created_by: localStorage.getItem("userID"),
      p_updated_by: localStorage.getItem("userID"),
      p_status:formData.status,
    };

    const endpoint = isEdit
      ? Warehouse_API_ENDPOINTS.warehousemapping.update
      : Warehouse_API_ENDPOINTS.warehousemapping.create;

    try {
      const res = await callApi(
        endpoint,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );
const message =
         res[0]?.message ||       // fallback if API returns plain object
          "Warehouse Mapping updated successfully!";
        // ✅ Success message
            toast.success(
             message,
              { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000 }
            );
      
      //showAlert("Data saved successfully!", "success");

      // ✅ Keep form open and switch to edit mode
      setIsEdit(true);

      // If API returns new ID, update formData so delete works
      if (!isEdit && res?.[0]?.p_mapping_id) {
        setFormData((prev) => ({
          ...prev,
          warehouse_mapping_id: res[0].p_mapping_id,
        }));
      }

      // Refresh list but do not close
      setTimeout(() => {
        LoadWarehouseMappingList();
      }, 800);
    } catch (error) {
      console.error("Error saving data:", error);
const errorMsg =
           error?.data?.message ||
           error?.message ||
           "Failed to save Warehouse Type";
         toast.error(errorMsg, {
           position: toast.POSITION.BOTTOM_CENTER,
           autoClose: 2000,
         });
      //showAlert("Error occurred while saving Warehouse Mapping details.", "error");
    }
  };

  // ✅ Delete
  const handleDelete = async () => {
    if (!isEdit || !formData.warehouse_mapping_id) return;

    try {
      const payload = {
        p_mapping_id: formData.warehouse_mapping_id,
        p_companyid: localStorage.getItem("companyid"),
        p_plantid: 1,
        p_deleted_by: localStorage.getItem("userID"),
      };

      await callApi(
        Warehouse_API_ENDPOINTS.warehousemapping.delete,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );

       toast.success("WarehouseMapping Deleted successfully!", 
        { position: toast.POSITION.BOTTOM_CENTER }, 
        { autoClose: 2000 });
      //showAlert("WarehouseMapping Deleted successfully!", "success");

      // Refresh and clear form
      setTimeout(() => {
        LoadWarehouseMappingList();
        handleClear();
      }, 1000);
    } catch (error) {
      console.error("Error deleting data:", error);
      toast.success("Error deleting Warehouse Mapping record!", 
        { position: toast.POSITION.BOTTOM_CENTER }, 
        { autoClose: 2000 });
      //showAlert("Error deleting Warehouse Mapping record.", "error");
    }
  };

  // ✅ Clear → new entry mode
  const handleClear = () => {
    setFormData({
      warehouse_mapping_id: null,
      warehouse_id: "",
      code: "",
      bin_type_id: "",
    });
    setIsEdit(false);
  };

  return (
    <Box fullWidth>
      <WarehouseMappingActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onClear={handleClear}
        onExit={() => setIsFormOpen(false)}
        saveDisabled={
          !formData.code || !formData.warehouse_id || !formData.bin_type_id
        }
      />

      <Divider />

      <Box p={3}>
        <Grid container spacing={2}>
          {/* 🔹 Zone & Package Mode */}
          <Grid item xs={8}>
            <Box display="grid" gridTemplateColumns={{ xs: "1fr 2fr", sm: "2fr 5fr" }} gap={2}>
              <Typography variant="h6" sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                Zone & Package Mode<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                color="secondary"
                value={formData.code || ""}
                onChange={(e) => handleChange("code", e.target.value)}
                inputProps={{ style: { color: "#fff" } }}
              >
                {zonePackageList.map((zp) => (
                  <MenuItem key={zp.code} value={zp.code}>
                    {`${zp.code}`}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          {/* 🔹 Warehouse */}
          <Grid item xs={8}>
            <Box display="grid" gridTemplateColumns={{ xs: "1fr 2fr", sm: "2fr 5fr" }} gap={2}>
              <Typography variant="h6" sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                Warehouse<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                color="secondary"
                name="warehouse_id"
                value={formData.warehouse_id || ""}
                onChange={(e) => handleChange("warehouse_id", e.target.value)}
                inputProps={{ style: { color: "#fff" } }}
              >
                {warehouses.map((wh) => (
                  <MenuItem key={wh.warehouse_id} value={wh.warehouse_id}>
                    {`${wh.code}`}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          {/* 🔹 Bin Type */}
          <Grid item xs={8}>
            <Box display="grid" gridTemplateColumns={{ xs: "1fr 2fr", sm: "2fr 5fr" }} gap={2}>
              <Typography variant="h6" sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                Bin Type<span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                color="secondary"
                value={formData.bin_type_id || ""}
                onChange={(e) => handleChange("bin_type_id", e.target.value)}
                inputProps={{ style: { color: "#fff" } }}
                disabled={!formData.warehouse_id}
              >
                {binTypes.map((bin) => (
                  <MenuItem key={bin.bin_type_id} value={bin.bin_type_id}>
                    {bin.code}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>
{/* ✅ Status (Active / Inactive Switch) */}
          <Grid item xs={12}>
            <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(12, 1fr)' }} gap={2} alignItems="center">
              <Box gridColumn="span 2">
                <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
                  Status
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
  <Switch
    checked={formData.status === undefined ? true : formData.status}
    color="secondary"
    onChange={(e) =>
      setFormData({
        ...formData,
        status: e.target.checked,
      })
    }
  />
  <Typography sx={{ ml: 1 }}>
    {formData.status === undefined
      ? "Active"
      : formData.status
      ? "Active"
      : "Inactive"}
  </Typography>
</Box>

              </Box>
            </Box>
          </Grid>

        </Grid>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddUpdateWarehousemapping;
